import { useEffect, useState } from "react"
import { firebaseDatabase } from "../config/firebase_config"
import UnderMaintenanceMode from "./under_maintenance_mode"

export default function MaintenanceGuard({ children }) {
  const [maintenance, setMaintenance] = useState(false)

  useEffect(() => {
    const docRef = firebaseDatabase.collection("settings").doc("vendor_portal")

    const unsubscribe = docRef.onSnapshot(
      (doc) => {
        if (doc.exists) {
          setMaintenance(doc.data().maintenance)
        }
      },
      (error) => {
        console.error("Error fetching maintenance status:", error)
      }
    )

    return () => unsubscribe()
  }, [])

  if (maintenance) return <UnderMaintenanceMode />
  return children
}
